import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["containerRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// ../../react-shim.js
import React from "react"; // src/portal-manager.tsx

import { createContext } from "@chakra-ui/react-context";

var _createContext = createContext({
  strict: false,
  name: "PortalManagerContext"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    PortalManagerContextProvider = _createContext2[0],
    usePortalManager = _createContext2[1];

function PortalManager(props) {
  var children = props.children,
      zIndex = props.zIndex;
  return /* @__PURE__ */React.createElement(PortalManagerContextProvider, {
    value: {
      zIndex: zIndex
    }
  }, children);
}

PortalManager.displayName = "PortalManager"; // src/portal.tsx

import { useSafeLayoutEffect } from "@chakra-ui/react-use-safe-layout-effect";
import { createContext as createContext2 } from "@chakra-ui/react-context";
import { createPortal } from "react-dom";
import { useEffect, useMemo, useRef, useState } from "react";

var _createContext3 = createContext2({
  strict: false,
  name: "PortalContext"
}),
    _createContext4 = _slicedToArray(_createContext3, 2),
    PortalContextProvider = _createContext4[0],
    usePortalContext = _createContext4[1];

var PORTAL_CLASSNAME = "chakra-portal";
var PORTAL_SELECTOR = ".chakra-portal";

var Container = function Container(props) {
  return /* @__PURE__ */React.createElement("div", {
    className: "chakra-portal-zIndex",
    style: {
      position: "absolute",
      zIndex: props.zIndex,
      top: 0,
      left: 0,
      right: 0
    }
  }, props.children);
};

var DefaultPortal = function DefaultPortal(props) {
  var appendToParentPortal = props.appendToParentPortal,
      children = props.children;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      tempNode = _useState2[0],
      setTempNode = _useState2[1];

  var portal = useRef(null);

  var _useState3 = useState({}),
      _useState4 = _slicedToArray(_useState3, 2),
      forceUpdate = _useState4[1];

  useEffect(function () {
    return forceUpdate({});
  }, []);
  var parentPortal = usePortalContext();
  var manager = usePortalManager();
  useSafeLayoutEffect(function () {
    if (!tempNode) return;
    var doc = tempNode.ownerDocument;
    var host = appendToParentPortal ? parentPortal !== null && parentPortal !== void 0 ? parentPortal : doc.body : doc.body;
    if (!host) return;
    portal.current = doc.createElement("div");
    portal.current.className = PORTAL_CLASSNAME;
    host.appendChild(portal.current);
    forceUpdate({});
    var portalNode = portal.current;
    return function () {
      if (host.contains(portalNode)) {
        host.removeChild(portalNode);
      }
    };
  }, [tempNode]);

  var _children = (manager == null ? void 0 : manager.zIndex) ? /* @__PURE__ */React.createElement(Container, {
    zIndex: manager == null ? void 0 : manager.zIndex
  }, children) : children;

  return portal.current ? createPortal( /* @__PURE__ */React.createElement(PortalContextProvider, {
    value: portal.current
  }, _children), portal.current) : /* @__PURE__ */React.createElement("span", {
    ref: function ref(el) {
      if (el) setTempNode(el);
    }
  });
};

var ContainerPortal = function ContainerPortal(props) {
  var children = props.children,
      containerRef = props.containerRef,
      appendToParentPortal = props.appendToParentPortal;
  var containerEl = containerRef.current;
  var host = containerEl !== null && containerEl !== void 0 ? containerEl : typeof window !== "undefined" ? document.body : void 0;
  var portal = useMemo(function () {
    var node = containerEl == null ? void 0 : containerEl.ownerDocument.createElement("div");
    if (node) node.className = PORTAL_CLASSNAME;
    return node;
  }, [containerEl]);

  var _useState5 = useState({}),
      _useState6 = _slicedToArray(_useState5, 2),
      forceUpdate = _useState6[1];

  useSafeLayoutEffect(function () {
    return forceUpdate({});
  }, []);
  useSafeLayoutEffect(function () {
    if (!portal || !host) return;
    host.appendChild(portal);
    return function () {
      host.removeChild(portal);
    };
  }, [portal, host]);

  if (host && portal) {
    return createPortal( /* @__PURE__ */React.createElement(PortalContextProvider, {
      value: appendToParentPortal ? portal : null
    }, children), portal);
  }

  return null;
};

function Portal(props) {
  var containerRef = props.containerRef,
      rest = _objectWithoutProperties(props, _excluded);

  return containerRef ? /* @__PURE__ */React.createElement(ContainerPortal, _objectSpread({
    containerRef: containerRef
  }, rest)) : /* @__PURE__ */React.createElement(DefaultPortal, _objectSpread({}, rest));
}

Portal.defaultProps = {
  appendToParentPortal: true
};
Portal.className = PORTAL_CLASSNAME;
Portal.selector = PORTAL_SELECTOR;
Portal.displayName = "Portal";
export { Portal, PortalManager, usePortalManager };